export default "__VITE_ASSET__zWYgxHTC__"